import { ApiClient } from "./api-client";

export function getStatistics(queryParams) {
  return ApiClient.getInstance().get('/statistics', { params: queryParams }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function getStatisticsFilters() {
  return ApiClient.getInstance().get('/statistics/filter').catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}